<template>
    <div class="form_field flex_field border-bottom pt-0">
      <div class="label_container">
        <label for="km">Inserisci i Km percorsi</label>
        <div class="sub_label" v-if="km">
          Se non li conosci verranno inseriti i km standard ({{ formattedKm }} km)
        </div>
      </div>
      <div class="input_container">
        <input
          id="km"
          type="text"
          :placeholder="formattedKmPlaceholder ? formattedKmPlaceholder : formattedKm"
          v-model="inputValue"
          @input="formatInput"
          inputmode="numeric"
          class="no-spinners"
          autocomplete="off"
        />
        <input type="hidden" name="km" :value="formattedKmPlaceholder ? formattedKmPlaceholder : numericValue" />
      </div>
    </div>
  </template>


<script>
export default {
  name: 'FormFieldKm',
  props: {
    km: {
      type: Number,
      required: true,
    },
    km_placeholder: {
      type: [Number, String],
      required: false,
    },
  },
  data() {
    return {
      inputValue: '',
      numericValue: this.km,
      showMaxKmWarning: false,
    };
  },
  computed: {
    formattedKm() {
      return this.numberWithThousandSeparator(this.km);
    },
    formattedKmPlaceholder() {
      return this.numberWithThousandSeparator(this.km_placeholder);
    }
  },
  methods: {
    numberWithThousandSeparator(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    formatInput() {
      let numericValue = this.inputValue.replace(/\D/g, '');
      if (numericValue === '') {
        this.inputValue = '';
        this.numericValue = this.km;
        this.showMaxKmWarning = false;
      } else {
        if (numericValue.length > 6) {
          numericValue = numericValue.slice(0, 6);
        } 
        let parsedValue = parseInt(numericValue, 10);
        this.inputValue = this.numberWithThousandSeparator(numericValue);
        this.numericValue = parsedValue;
      }
      this.$emit('input', this.numericValue);
    },
  },
  mounted() {
    this.$emit('input', this.km);
    this.numericValue = this.km;
  },
};
</script>

<style scoped>
.pt-0 {
  padding-top: 0;
}


</style>


// WEBPACK FOOTER //
// resources/js/app/components/FormFieldKm.vue